<div class="pb-2">
    <div class="mb-0 flex content-between items-center" mat-dialog-title>
        <div class="w-full font-bold text-lg">
            {{ config.title }}
        </div>
        <button *ngIf="canClose" mat-icon-button (click)="onClose()">
            <mat-icon svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>
    <hr class="separator max-w-full mb-2" />
</div>
<mat-dialog-content class="grow">
    <app-dynamic-container
        #dcContainer
        [standalone]="true"
        [descriptor]="config.descriptor"
    ></app-dynamic-container>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="flex justify-between w-full asdadwqefcwefwsfwf">
        <span class="text-left flex align-center">
            <ng-container *ngFor="let button of leftButtons; let idx = index">
                <button
                    type="button"
                    mat-flat-button
                    (click)="onLeftButtonClick(idx)"
                    [matTooltip]="button.tooltip"
                    [class.hidden]="!button.visible"
                    [disabled]="button.disabled"
                >
                    <mat-icon
                        *ngIf="button.icon"
                        class="mr-1"
                        [svgIcon]="button.icon"
                    ></mat-icon>
                    {{ button.title }}
                </button>
            </ng-container>
        </span>
        <span class="text-right flex align-center">
            <button
                *ngIf="button2.visible"
                type="button"
                mat-flat-button
                (click)="onButton2Click()"
                [matTooltip]="button2.tooltip"
                [class.hidden]="!button2.visible"
                [disabled]="button2.disabled"
            >
                <mat-icon
                    *ngIf="button2.icon"
                    class="mr-1"
                    [svgIcon]="button2.icon"
                ></mat-icon>
                {{ button2.title }}
            </button>
            <button
                *ngIf="button1.visible"
                type="button"
                mat-flat-button
                (click)="onButton1Click()"
                [matTooltip]="button1.tooltip"
                [class.hidden]="!button1.visible"
                [disabled]="button1.disabled"
                color="primary"
            >
                <mat-icon
                    *ngIf="button1.icon"
                    class="mr-1"
                    [svgIcon]="button1.icon"
                ></mat-icon>
                {{ button1.title }}
            </button>
            <ng-container *ngFor="let button of rightButtons; let idx = index">
                <button
                    type="button"
                    mat-flat-button
                    (click)="onRightButtonClick(idx)"
                    [matTooltip]="button.tooltip"
                    [class.hidden]="!button.visible"
                    [disabled]="button.disabled"
                >
                    <mat-icon
                        *ngIf="button.icon"
                        class="mr-1"
                        [svgIcon]="button.icon"
                    ></mat-icon>
                    {{ button.title }}
                </button>
            </ng-container>
        </span>
    </div>
</mat-dialog-actions>
